import { useEffect, useState } from "react";
import {Tabs,Tab} from 'react-bootstrap';
import { TopBar } from "../../shared/topBar/TopBar";
import { UrlPath } from "../../../config/routeConfig";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { getPortFolioCashAction, getPortFolioCreditFacilityAction, getPortFolioCurrencyAction, getPortFolioDetailAction, getPortFolioDiscretionaryStatusAction, getPortFolioExpenseAction, getPortFolioListAction, getPortFolioManagerAction, getPortFolioTaxStatusAction, getPortFolioTypeAction } from "../../actions/portfolioAction";
import { AgGridReact } from "ag-grid-react";
import { sbaAxios } from "../../utils/sbaAxios";
import { getPortfolioExistingAsset } from "../../../config/apiConfig";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { PortfolioEditor } from "../portfolioList/portfolioList";
import { ToastContainer } from "react-toastify";
import { SBAComboBox } from "../../UiComponents/SBADropDown";

export const NewPortfolio = {
    "PortfolioId": 0,
    "PortfolioName": "",
    "Abbreviation": "",
    "LinkedAssetId": 0,
    "LinkedAssetName": "",
    "Description": "",
    "PortfolioTypeId": 0,
    "PortfolioTypeName": "",
    "DefaultCurrencyId": 0,
    "DefaultCurrencyName": "",
    "DefaultCashId": 0,
    "DefaultCashAccountName": "",
    "DefaultExpenseId": 0,
    "DefaultExpenseAccountName": "",
    "CreditFacilityAccountId": 0,
    "DefaultCreditFacilityAccountName": "",
    "PortfolioManagerId": 0,
    "PortfolioManagerName": "",
    "TaxStatusId": 0,
    "TaxStatusName": "",
    "DiscretionaryStatusId": 0,
    "DiscretionaryStatusName": "",
    "IsQualifiedInvestor": false,
    "IsPartnership": false,
    "BillingExclusion": false,
    "CustodyStatus": false,
    "InternalEmployee": false,
    "CharitableStatus": false,
    "PPLI": false,
    "Notes": "",
    "CloseDate": null,
    "StartDate": "",
    "CreatedBy": 0,
    "CreatedByName": "",
    "TaxEntityId":null,
    "TaxEntityName":"",
    "FamilyId":null,
    "FamilyName":""
};
export const PortfolioDetails=({})=>{
    const params = useParams();
    const dispatch = useDispatch();
    const history=useNavigate();
    const portfolioId=params.PortfolioId;
    const Gstate = useSelector(state => state);
    const Stateportfolio = Gstate.portfolio.portfolio;
    const portfolioList = Gstate.portfolio.portfolioList;
    const portfolioLoading = Gstate.portfolio.isPortfolioDetailLoading;   
    const isEditable = useSelector(state => state.authorizationData.isEditable);
    const [isEdit, setIsEdit] = useState(isEditable);
    useEffect(() => { setIsEdit(isEditable) }, [isEditable])

    const [drawer,setDrawer]=useState(false);
    const [operation,setOperation]=useState(null);

    const Level = [{ BreadCrumb: "Portfolio >", Routes: `/${UrlPath.PortfolioList}` },{ BreadCrumb: `${Stateportfolio.PortfolioName}`, Routes: `/${UrlPath.PortfolioDetails}${portfolioId}` }];
    useEffect(()=>{
        document.title="Portfolio Details";
        dispatch(getPortFolioListAction(null));
        dispatch(getPortFolioDiscretionaryStatusAction());
        dispatch(getPortFolioTaxStatusAction());
        dispatch(getPortFolioManagerAction());
        dispatch(getPortFolioCreditFacilityAction());
        dispatch(getPortFolioExpenseAction());
        dispatch(getPortFolioCashAction());
        dispatch(getPortFolioCurrencyAction());
        dispatch(getPortFolioTypeAction());
    },[]);

    useEffect(()=>{
        dispatch(getPortFolioDetailAction(portfolioId));
    },[portfolioId]);
    const portfolioDropDownChange=(e)=>{
        if(e.value)
        {
            const pID=e.value.PortfolioId;
            dispatch(getPortFolioDetailAction(pID));
            history(`/${UrlPath.PortfolioDetails}${pID}`);
        }
    }
    return <>
         <TopBar label={"Portfolio Details"} />
        <div className="mainContentData">
       
            <BreadCrumbs Levels={Level} />
            <div className="p-4">
                <div className="d-flex justify-content-between">
                <div>
                <h2 class="fw-medium fs-6 m-0">{Stateportfolio.PortfolioName}</h2>
                </div>
                <div className="d-flex w-50 justify-content-end">
                <SBAComboBox  data={portfolioList} className="w-50" onChange={portfolioDropDownChange} textField={"PortfolioName"} valueField={"PortfolioId"} value={Stateportfolio}/>
                <button class="p-sm-btn mx-1" disabled={!isEdit} onClick={()=>{setDrawer(true); setOperation("Add")}}><i class="fa-solid fa-plus"></i> Add</button>
                </div>
                </div>
                <Tabs
                    defaultActiveKey={'Details'}
                    // id="uncontrolled-tab-example"
                    style={{borderBottom:"none"}}
                    className="ms-3"
                >
                    <Tab eventKey="Details" title="Details">
                        <div class="p-3 bg-white life-science rounded">
                            <PortfolioContainer setDrawer={setDrawer} drawer={drawer} operation={operation} setOperation={setOperation} />
                        </div>
                    </Tab>
                </Tabs>
            </div>
          
            </div>
            <ToastContainer/>
            
    </>
};
const PortfolioContainer=({setDrawer,drawer,setOperation,operation})=>{
    const dispatch = useDispatch();
    const Gstate = useSelector(state => state);
    const Stateportfolio = Gstate.portfolio.portfolio;
    const portfolioLoading = Gstate.portfolio.isPortfolioDetailLoading;   
    const editPortfolio = () => {
        if (isEdit) {
            setOperation('Update');
            setDrawer(true);
        }
    };
    const afterPortfolioSave=(pID)=>{
        dispatch(getPortFolioDetailAction(pID));
    };


    const isEditable = useSelector(state => state.authorizationData.isEditable);
    const [isEdit, setIsEdit] = useState(isEditable);
    useEffect(() => { setIsEdit(isEditable) }, [isEditable]);


    return <>
         {portfolioLoading ? <><LoadingScreen /></> : <>
            <div className="position-relative">
                <div className="detail p-4">
                <i className={`fa-solid fa-pencil position-absolute  ${isEdit ? 'text-primary hoverHand': 'text-secondary'} `} style={{left:"97%"}} onClick={()=>{editPortfolio()}}/>
                <div className="row mb-4">
                    <LabelViewer label={"Portfolio Name"} value={Stateportfolio?.PortfolioName} colSpan={"col-md-3"} />
                    <LabelViewer label={"Abbreviation"} value={Stateportfolio?.Abbreviation} colSpan={"col-md-3"} />
                    <LabelViewer label={"Description"} value={Stateportfolio?.Description} colSpan={"col-md-3"} />
                    <LabelViewer isCheckbox label={"Qualified Investor"} value={Stateportfolio?.IsQualifiedInvestor} colSpan={"col-md-3"} />
                </div>
                    <div className="row mb-4">
                        <LabelViewer label={"Family"} value={Stateportfolio?.FamilyName} colSpan={"col-md-3"} />
                        <LabelViewer label={"Linked Asset"} value={Stateportfolio?.LinkedAssetName} colSpan={"col-md-3"} />
                        <LabelViewer label={"Linked Account"} value={Stateportfolio?.TaxEntityName} colSpan={"col-md-3"} />
                        <LabelViewer isCheckbox label={"Custody Status"} value={Stateportfolio?.CustodyStatus} colSpan={"col-md-3"} />
                    </div>
                    <div className="row mb-4">
                        <LabelViewer label={"Portfolio Type"} value={Stateportfolio?.PortfolioTypeName} colSpan={"col-md-3"} />
                        <LabelViewer label={"Default Currency"} value={Stateportfolio?.DefaultCurrencyName} colSpan={"col-md-3"} />
                        <LabelViewer isDateField label={"Close Date"} value={Stateportfolio?.CloseDate} colSpan={"col-md-3"} />
                        <LabelViewer isCheckbox label={"Private Placement Life Insurance"} value={Stateportfolio?.PPLI} colSpan={"col-md-3"} />
                    </div>
                    <div className="row mb-4">
                        <LabelViewer label={"Portfolio Manager"} value={Stateportfolio?.PortfolioManagerName} colSpan={"col-md-3"} />
                        <LabelViewer label={"Tax Status"} value={Stateportfolio?.TaxStatusName} colSpan={"col-md-3"} />
                       <div className="col-md-3"></div>
                        {/* <LabelViewer isCheckbox label={"Partnership"} value={Stateportfolio?.IsPartnership} colSpan={"col-md-3"} /> */}
                        <LabelViewer isCheckbox label={"Internal Employee"} value={Stateportfolio?.InternalEmployee} colSpan={"col-md-3"} />

                    </div>
                    <div className="row mb-4">
                        <LabelViewer label={"Default Cash Account"} value={Stateportfolio?.DefaultCashAccountName} colSpan={"col-md-3"} />
                        <LabelViewer label={"Default Expense Account"} value={Stateportfolio?.DefaultExpenseAccountName} colSpan={"col-md-3"} />
                        <LabelViewer label={"Credit Facility Account"} value={Stateportfolio?.DefaultCreditFacilityAccountName} colSpan={"col-md-3"} />
                        <LabelViewer isCheckbox label={"Partnership"} value={Stateportfolio?.IsPartnership} colSpan={"col-md-3"} />
                       
                        {/* <LabelViewer isCheckbox label={"Billing Exclusion"} value={Stateportfolio?.BillingExclusion} colSpan={"col-md-3"} /> */}
                    </div>
                    <div className="row mb-4">
                    <LabelViewer label={"Notes"} value={Stateportfolio?.Notes} colSpan={"col-md-3"} />
                    <div className="col-md-6"></div>
                    <LabelViewer isCheckbox label={"Charitable Status"} value={Stateportfolio?.CharitableStatus} colSpan={"col-md-3"} />
                </div>
                </div>
                <div>
                    <InvestmentAssetContainer portfolioId={Stateportfolio?.PortfolioId} />
                </div>
            </div>
            <SBADrawer open={drawer} setOpen={setDrawer} title={`${operation} Portfolio`} size='85vw'>
                <PortfolioEditor afterSave={afterPortfolioSave} setDrawer={setDrawer} operation={operation}/>
            </SBADrawer>
            </>
        }
    </>
};
const InvestmentAssetContainer = ({ portfolioId }) => {
    const [gridData, setGridData] = useState([]);
    useEffect(() => {
        if(portfolioId)
        getGridData();
    }, [portfolioId])
    const getGridData = () => {
        sbaAxios({ url: `${getPortfolioExistingAsset}${portfolioId}` }).then(res => {
            setGridData(res);
        }).catch(error => {
            console.log('Error Loading Data For Investment Asset ');
        })
    };
    
    const existingInvestDef = [
        { field: "AssetName", headerName: "Asset Name", flex: 1, filter: "agTextColumnFilter", floatingFilter: true, minWidth: 400 , pinned:'left'},
        { field: "AssetType", headerName: "Asset Type", flex: 0.5, filter: "agTextColumnFilter", floatingFilter: true },
        { field: "StrategyName", headerName: "Strategy Name", flex: 0.5, filter: "agTextColumnFilter", floatingFilter: true },
        { field: "Type", headerName: "Type", flex: 0.5, filter: "agTextColumnFilter", floatingFilter: true },
        { field: "AccountingMode", headerName: "Accounting Mode", flex: 0.5, filter: "agTextColumnFilter", floatingFilter: true },
        { field: "ChartOfAccount", headerName: "Chart Of Account", flex: 0.5, filter: "agTextColumnFilter", floatingFilter: true },
        { field: "InitialAllocationDate", headerName: "Initial Allocation Date", flex: 0.5, filter: "agTextColumnFilter", floatingFilter: true, valueFormatter: formatIsoToDateString },
    ];

    return <div className="ag-theme-alpine" style={{ height: '500px' }}>
        <AgGridReact
            columnDefs={existingInvestDef}
            rowData={gridData}
            defaultColDef={{minWidth:200 ,resizable:true,lockPosition:true}}
            pagination={true}
            paginationPageSize={10}
            rowSelection="single"
        >
        </AgGridReact></div>
};
const LabelViewer=({label,colSpan,value,isCheckbox ,isDateField})=>{
    const fieldValue=isDateField ? getFormattedDate(value) :getFormattedLabel(value);
    return <>
    {isCheckbox ? <div className={colSpan +" d-flex align-items-center mb-2"}>
     <input type="checkbox" checked={value} className="me-3"/>
            <span class={!isCheckbox &&`fw-medium`} style={{fontSize:"12px"}}>
                {label}
            </span>
     </div> :
     <div className={colSpan + ' mb-2'}>
     <span className={`fw-medium`} style={{fontSize:"12px"}}>
                {label}
            </span>
            <p className="fw-medium">{fieldValue}</p>
     </div>}
    </>
};
const formatIsoToDateString = (params) => {
    const value = params.value;
    if (value)
        return moment(value).format("MM-DD-YYYY");
    else
        return "";
};
const getFormattedDate=(value)=>{
    const formattedDate=moment(value).format('MM-DD-YYYY')
    if(formattedDate==='Invalid date')
        return "-";
    else return formattedDate;
};
const getFormattedLabel=(value)=>{
    if(value)
       return value
    else  return "-";;
}